import { ReactNode } from 'react';

interface PanelProps {
  title: string;
  children: ReactNode;
  isSidebar?: boolean;
}

export function Panel(props: PanelProps) {
  const panelClass = props.isSidebar ? 'c-panel -sidebar' : 'c-panel';
  return (
    <div className="u-pl10 u-pr10">
      <div className={panelClass}>
        <h2 className="c-panel__header">{props.title}</h2>
        <div className="c-panel__body">{props.children}</div>
      </div>
    </div>
  );
}
